/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_S5_TitleInputs */

const en_guide_json_vs_yaml_xml_s5_title = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When to Use Each Format`)
};

const ko_guide_json_vs_yaml_xml_s5_title = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`각 포맷을 언제 사용할까`)
};

const ja_guide_json_vs_yaml_xml_s5_title = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各フォーマットの使いどころ`)
};

/**
* | output |
* | --- |
* | "When to Use Each Format" |
*
* @param {Guide_Json_Vs_Yaml_Xml_S5_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_s5_title = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_S5_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_S5_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_s5_title(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_s5_title(inputs)
	return ja_guide_json_vs_yaml_xml_s5_title(inputs)
});